const HEX_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

/**
 * Validates whether a value is a 6-digit hex color with a leading `#`.
 *
 * @param value - Raw color value from user input.
 * @returns True when the value is a valid hex color.
 */
export const isValidSixDigitHexColor = (value: string): boolean => HEX_COLOR_PATTERN.test(value.trim());
